// @ts-expect-error $quartzConfigVal types need work
if (undefined !== true) {
  // @ts-expect-error untyped global variable
  window.hubspot['__hub-http-labs'] = window.hubspot['__hub-http-labs'] || {};

  // @ts-expect-error untyped global variable
  window.hubspot['__hub-http-labs']['HUBONEDOMAIN'] = true;
}